import { useCallback, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { TfiReload } from "react-icons/tfi";
import { httpGet } from "../http/request";
import { useUsuario } from "../context/UsuarioContext";

const colorEstado = (estado) => {
  const e = (estado || "").toLowerCase();
  if (e.includes("activo")) return "bg-success";
  if (e.includes("bloqueado") || e.includes("devoluci")) return "bg-warning";
  if (e.includes("anulado") || e.includes("deshabilitado")) return "bg-danger";
  return "bg-secondary";
};

const MisCarrerasEstudiante = () => {
  const { setSpinnerLoad } = useUsuario();
  const [carreras, setCarreras] = useState([]);

  const loadData = useCallback(() => {
    setSpinnerLoad(true);
    httpGet("/api/v1/postulante/mis_carreras")
      .then((d) => {
        if (d) setCarreras(d);
      })
      .finally(() => setSpinnerLoad(false));
  }, [setSpinnerLoad]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (carreras.length === 0) {
    return <></>;
  }

  return (
    <Col sm={12} className="mg-t-20">
      <div className="card">
        <div className="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">
          <h6 className="tx-uppercase tx-semibold mg-b-0">Carreras en las que se encuentra matriculado</h6>
          <button className="btn btn-sm pd-x-15 btn-white" onClick={loadData}>
            <TfiReload />
          </button>
        </div>
        <div className="table-responsive">
          <table className="table table-dashboard mg-b-0">
            <thead>
              <tr>
                <th className="fw-bold">R.U.</th>
                <th className="fw-bold">Carrera</th>
                <th className="fw-bold">Modalidad de admisión</th>
                <th className="fw-bold">Gestión de ingreso</th>
                <th className="fw-bold">Fecha de inscripción</th>
                <th className="fw-bold">Estado</th>
              </tr>
            </thead>
            <tbody>
              {carreras.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center tx-color-03">
                    No se encontraron carreras registradas.
                  </td>
                </tr>
              ) : (
                carreras.map((c, i) => (
                  <tr key={i}>
                    <td>{c.ru}</td>
                    <td>{c.carrera}</td>
                    <td>{c.modalidad_admision}</td>
                    <td>{c.gestion_ingreso}</td>
                    <td>{c.fecha_inscripcion}</td>
                    <td>
                      <span className={`badge ${colorEstado(c.estado)}`}>{c.estado}</span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Col>
  );
};

export default MisCarrerasEstudiante;
